import React from 'react';
import '../Scheduling.css';
import {
  FaClock,
  FaHospital,
  FaStethoscope,
  FaUser,
  FaVideo,
} from 'react-icons/fa';
import { useTeleconsultingContext } from 'contexts/TeleconsultingContext';

export function CardScheduleDetails({ resource }) {
  const { compareDates } = useTeleconsultingContext();
  const daysOfWeek = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

  const data = resource?.start.replace(/\s/g, '');
  const dateAppointment = new Date(data);

  const dayWeek = daysOfWeek[dateAppointment.getUTCDay()];
  const day = String(dateAppointment.getUTCDate()).padStart(2, '0');
  const month = String(dateAppointment.getUTCMonth() + 1).padStart(2, '0');
  const hours = String(dateAppointment.getHours()).padStart(2, '0');
  const minutes = String(dateAppointment.getMinutes()).padStart(2, '0');

  const dataScreen = `${dayWeek}, ${day}/${month}`;
  const displayAppointment =
    resource?.serviceType?.[0]?.coding?.[0]?.display ||
    resource?.appointmentType?.text ||
    '-';
  const location = resource?.participant?.find(
    (el) => el?.actor?.type === 'Location',
  )?.actor?.display;
  const timeScreen = `${hours}: ${minutes}`;

  const practitioner =
    resource?.contained?.find((item) => item?.resourceType === 'Practitioner')
      ?.name?.[0]?.text || '-';

  const teleconsultUrl = resource?.comment;
  const isVirtual =
    resource?.appointmentType?.coding?.[0]?.code === 'TELEATENDIMENTO';
  const isAvailable = compareDates(data);

  const handleTeleconsult = () => {
    if (teleconsultUrl && isAvailable) window.open(teleconsultUrl, '_blank');
  };

  return (
    <div className="cardDetails">
      <div className="alignContent alignCenter">
        <p className="blueTitle">{dataScreen || '-'}</p>
        <p>
          <FaClock className="colorIcons" />
          <span className="hourDisplay"> {timeScreen}</span>
        </p>
      </div>
      <div className="verticalLine" />
      <div className="alignContent alignLeft">
        {displayAppointment && (
          <p className="detailsCard">
            <FaStethoscope className="colorIcons " />
            <p className="locationText"> {displayAppointment || '-'} </p>
            {/* <div
            style={{ borderLeft: '2px solid #c3c3c3', margin: '0px 10px' }}
          />
          <FaLocationArrow className="colorIcons " />
          <p className="aditionalInformation">
            Rua 235 QD. 68 Lote Área, Nº 285, s/nº - Setor Leste Universitário
            (HardC)
          </p> */}
          </p>
        )}

        {location && (
          <p className="detailsCard">
            <FaHospital className="colorIcons " />
            <p className="locationText"> {location || '-'} </p>
            {/* <div
      style={{ borderLeft: '2px solid #c3c3c3', margin: '0px 10px' }}
    />
    <FaLocationArrow className="colorIcons " />
    <p className="aditionalInformation">
      Rua 235 QD. 68 Lote Área, Nº 285, s/nº - Setor Leste Universitário
      (HardC)
    </p> */}
          </p>
        )}

        {practitioner && (
          <p className="detailsCard">
            <FaUser className="colorIcons " />
            <p className="locationText"> {practitioner || '-'} </p>
            {/* <div
            style={{ borderLeft: '2px solid #c3c3c3', margin: '0px 10px' }}
          />
          <FaLocationArrow className="colorIcons " />
          <p className="aditionalInformation">
            Rua 235 QD. 68 Lote Área, Nº 285, s/nº - Setor Leste Universitário
            (HardC)
          </p> */}
          </p>
        )}

        {isVirtual && teleconsultUrl && isAvailable && (
          <p className="detailsCard">
            <FaVideo className="colorIcons" />
            <p
              className={`locationText teleconsultLink ${
                !isAvailable ? 'teleconsultDisabled' : ''
              }`}
              onClick={handleTeleconsult}
              role="button"
              tabIndex={0}
            >
              Acessar Teleconsulta
            </p>
          </p>
        )}
      </div>
    </div>
  );
}
